import React, { useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import {
  KeyboardDatePicker
} from '@material-ui/pickers';

import {
  Box,
  Link,
  Card,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  makeStyles,
  Grid,
  colors,
  Avatar,
  Icon,
  Typography,
  Button,
  TextField,
  InputAdornment,
  SvgIcon,
  TablePagination,
  Paper,
  FormControl,
  FormGroup,
  FormControlLabel,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';
import Add from '@material-ui/icons/AddCircleOutline';

import Pager from 'src/utils/Pager';
import agm from '../../services/agm';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));


const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const defaultOccurenceTypes = {
  corretiva: true,
  preventiva: true,
  avcb: true,
  pendencia: true
}

const defaultDependencies = {
  loaded: false,
  types: [],
  technicians: []
}

const Toolbar = ({ icon, item, resultset, resultModes, vision, visions, selectedMode, openCreation, changeFilter }) => {

  const classes = useStyles();

  const [startDateTime, setStartDateTime] = useState(defaultStartDateTime);
  const [endDateTime, setEndDateTime] = useState(defaultEndDateTime);
  const [keyword, setKeyword] = useState('');
  const [query, setQuery] = useState(vision);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(100);
  const [typeTechnician, setTypeTechnician] = useState(-1);
  const [technician, setTechnician] = useState((localStorage.getItem('userexternalid') && localStorage.getItem('userexternalid') != '') ? localStorage.getItem('userexternalid') : 99999999);

  const [dependencies, setDependencies] = useState(defaultDependencies);

  const changeStartDatetime = (value) => {
    setStartDateTime(value);
    setPage(0);
    changeFilter(value,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      technician,
      typeTechnician)
  }

  const changeEndDatetime = (value) => {
    setEndDateTime(value);
    setPage(0);
    changeFilter(startDateTime,
      value,
      query,
      keyword,
      0,
      rows,
      technician,
      typeTechnician);
  }

  const changeTechnician = (event) => {
    setTechnician(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      event.target.value,
      typeTechnician);
  }

  const changeTypeTechnician = (event) => {
    setTypeTechnician(event.target.value);
    setPage(0);
    loadDependencies(event.target.value);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rows,
      -1,
      event.target.value);
  }

  const changeQuery = (event) => {
    setQuery(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      event.target.value,
      keyword,
      0,
      rows,
      technician,
      typeTechnician);
  }

  const changeKeyword = (event) => {
    setKeyword(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      event.target.value,
      0,
      rows,
      technician,
      typeTechnician);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      newPage,
      rows,
      technician,
      typeTechnician);
  };

  const handleChangeRowsPerPage = (event) => {
    var rowsPerPage = event.target.value;
    setRows(rowsPerPage);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      0,
      rowsPerPage,
      technician,
      typeTechnician);
  };

  const loadDependencies = ((value) => {
    agm.get('/tecnicos', {}, {}).then((response) => {
      setTechnician(-1);
      setDependencies({
        types: [],
        technicians: response.data
      });
      setTechnician(value);
    }).catch((error) => {
      console.error(error);
    })
  });

  useEffect(() => {
    return
  }, []);

  return (
    <Fragment>
      <Box className={classes.baroperation}>

        <Grid container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
        >
          <Grid item
            md="auto"
            xs="auto">
            <Avatar variant="rounded"
              className={classes.avatar}
            >
              {<Icon className={classes.iconoperation} component={icon} style={{ color: colors.green[600] }} ></Icon>}
            </Avatar>

          </Grid>

          <Grid item
            md="auto"
            xs="auto">
            <Typography
              color="primary"
              variant="h5"
            >
              Você esta na área do <b>{<Link color="inherit" href="/mgt/main">FINANCEIRO</Link>}</b>. A operação padrão é <b> {localStorage.getItem('company')}</b>
            </Typography>

            <Typography
              color="secondary"
              variant="h4"
            >
              <b>Caixinha</b>
            </Typography>

          </Grid>
        </Grid>
      </Box>

      <Box>
        <Card>
          <CardContent>
            <Grid container
              fullWidth
              direction="row"
              justify="flex-start"
              alignItems="flex-end"
            >
              <Grid item
                md={12}
                xs={12}>

                <Box mb={2}>
                  <Card>
                    <CardContent>
                      <Grid container
                        fullWidth
                        direction="row"
                        justify="flex-start"
                        alignItems="flex-start"
                        alignContent="flex-start"
                      >
                        <Grid item
                          xs={12}
                        >
                          <Grid container justifyContent="flex-start" spacing={2}>
                            <Grid item
                              md={3}
                              xs={12}
                            >
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="query">Pesquisa</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Pesquisa"
                                  variant="outlined"
                                  id="query"
                                  name="query"
                                  value={query}
                                  onChange={changeQuery}
                                  inputProps={{
                                    name: 'query',
                                    id: 'query',
                                  }}
                                >

                                  {visions.map((view) => (
                                    <MenuItem key={view.id} value={view}>{view.name}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid item
                              md={4}
                              xs={12}
                            >
                              <TextField
                                fullWidth
                                disabled={!query.refine}
                                onChange={changeKeyword}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SvgIcon
                                        fontSize="small"
                                        color="action"
                                      >
                                        <SearchIcon />
                                      </SvgIcon>
                                    </InputAdornment>
                                  )
                                }}
                                placeholder={"Refinar pesquisa por, " + query.label}
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid item
                              md={2}
                              xs={12}>

                            </Grid>

                            <Grid item
                              md={2}
                              xs={12}>

                            </Grid>

                          </Grid>

                        </Grid>

                      </Grid>

                    </CardContent>

                  </Card>
                </Box>

              </Grid>

              <Grid item
                md={7}
                xs={12}
              >
                <Grid container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >

                  <Grid item
                    md={10}
                    xs={12}
                  >

                    <TablePagination
                      style={{ minWidth: 295 }}
                      variant="caption"
                      component={Paper}
                      className={classes.pager}
                      page={page}
                      rowsPerPage={rows}
                      count={resultset.count}
                      labelRowsPerPage={(screen.width <= 480) ? "" : "Linhas por página"}
                      labelDisplayedRows={(screen.width <= 480) ? (({ from, to, count }) => `${from}-${to} de ${count}`) : (({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`)}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={Pager}
                    />

                  </Grid>


                </Grid>

              </Grid>

              <Grid item
                md={5}
                xs={12}
                style={(resultset.balance && resultset.balance >= 0) ? { padding: '10px', color: 'blue' } : { padding: '10px', color: 'red' }}
              >
                <Grid container
                  alignItems="flex-start"
                  justifyContent='space-around'
                >

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    <Typography variant='h3' >Créditos:</Typography>
                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    <Typography variant='h3' >{numeral(resultset.credits).format('0.00').replace('.', ',')}</Typography>
                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    <Typography variant='h3' >Débitos:</Typography>
                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    <Typography variant='h3' >{numeral(resultset.debits).format('0.00').replace('.', ',')}</Typography>
                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    <Typography variant='h3' >Saldo:</Typography>
                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    <Typography variant='h3' >{numeral(resultset.balance).format('0.00').replace('.', ',')}</Typography>
                  </Grid>

                </Grid>

              </Grid>

              <Grid item
                md={2}
                xs={12}
              >
                <Grid container
                  direction="row-reverse"
                  justify="baseline"
                  alignItems="flex-start"
                >

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    {(resultModes[selectedMode].create != LEVEL_ACCESS_HIDE) ? (
                      <Box mt={2} >
                        <Button
                          color="secondary"
                          disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED || technician == 99999999}
                          size="small"
                          variant="contained"
                          startIcon={<Add />}
                          onClick={() => { openCreation(item) }}>
                          Efetuar Lançamento
                        </Button>
                      </Box>
                    ) : ('')}

                  </Grid>



                </Grid>

              </Grid>


            </Grid>

          </CardContent>

        </Card>

      </Box>

    </Fragment>

  );
};


Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
